module.exports = __webpack_public_path__ + "img/what4.0b0776e3.png";